import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Fetches the latest catalog (flattened regulator → standard → chapter
 * nodes) for the current org. tRPC-only — there is no GraphQL equivalent, so this
 * is a thin direct `useQuery` wrapper rather than a `createQueryHook` bridge.
 */
export const useGetCatalog = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const trpc = useTRPC();

  return useQuery({
    ...trpc.frontend.ingestionConfig.getCatalog.queryOptions(),
    enabled,
  });
};
